var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "suspend-container" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "suspend-content" }, [
      _c("div", { staticClass: "icon-container" }, [
        _c("div", { staticClass: "suspend-icon" }, [
          _c(
            "svg",
            {
              attrs: {
                width: "40",
                height: "40",
                viewBox: "0 0 60 60",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("rect", {
                attrs: {
                  x: "18",
                  y: "26",
                  width: "24",
                  height: "20",
                  rx: "3",
                  fill: "white",
                  stroke: "white",
                  "stroke-width": "2",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M24 26V18C24 14.6863 26.6863 12 30 12C33.3137 12 36 14.6863 36 18V26",
                  stroke: "white",
                  "stroke-width": "3",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("circle", {
                attrs: { cx: "30", cy: "34", r: "2", fill: "#f16a52" },
              }),
              _vm._v(" "),
              _c("rect", {
                attrs: {
                  x: "29",
                  y: "36",
                  width: "2",
                  height: "6",
                  rx: "1",
                  fill: "#f16a52",
                },
              }),
              _vm._v(" "),
              _c("line", {
                attrs: {
                  x1: "14",
                  y1: "15",
                  x2: "14",
                  y2: "45",
                  stroke: "white",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  opacity: "0.6",
                },
              }),
              _vm._v(" "),
              _c("line", {
                attrs: {
                  x1: "46",
                  y1: "15",
                  x2: "46",
                  y2: "45",
                  stroke: "white",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  opacity: "0.6",
                },
              }),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("h1", { staticClass: "suspend-title" }, [
        _vm._v("Hesabınız Askıya Alınmıştır"),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "suspend-description" }, [
        _vm._v(
          "\n                Hesabınızın tekrar aktif hale getirilmesi için lütfen aşağıdaki iletişim kanallarından bizimle iletişime geçin.\n            "
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "contact-info" }, [
        _c("div", { staticClass: "contact-item" }, [
          _c("div", { staticClass: "contact-icon" }, [
            _c(
              "svg",
              {
                attrs: {
                  width: "16",
                  height: "16",
                  viewBox: "0 0 24 24",
                  fill: "none",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z",
                    stroke: "#f16a52",
                    "stroke-width": "2",
                  },
                }),
                _vm._v(" "),
                _c("polyline", {
                  attrs: {
                    points: "22,6 12,13 2,6",
                    stroke: "#f16a52",
                    "stroke-width": "2",
                  },
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm._m(1),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "contact-divider" }),
        _vm._v(" "),
        _c("div", { staticClass: "contact-button-container" }, [
          _c(
            "button",
            {
              staticClass: "contact-button",
              on: { click: _vm.connectSupportTeam },
            },
            [
              _c("span", { staticClass: "contact-button-icon" }, [
                _vm._v("💬"),
              ]),
              _vm._v(" "),
              _c("span", [_vm._v("İletişime Geç")]),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "company-logo-header" }, [
      _c("img", {
        attrs: {
          src: "https://static.supsis.live/common/supsisAiLogo.png",
          alt: "Supsis Logo",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "contact-details" }, [
      _c("div", { staticClass: "contact-label" }, [_vm._v("E-mail")]),
      _vm._v(" "),
      _c("div", { staticClass: "contact-value" }, [_vm._v("info@supsis.com")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }